import EventEmitter from './Experience/Utils/EventEmitter';
import Events from './Experience/Utils/Events';

export default class Driving {

    constructor() {
        this.Events = Events;
        this.EventEmitter = new EventEmitter();
        this.detailArt = document.getElementById('dettaglio');
        this.ClickEvent = new Event('click');
        this.ChangeOrientation = new Event('change');
        this.fullScreenBtn = document.querySelector('.fullscreen-button');
        //this.exitFullScreenDiv = document.querySelector('.exit-fullscreen');
        this.exitFullScreenBtn = document.querySelector('.exit-fullscreen-button');
        this.EnterButton = document.querySelector('.enter-button');
        this.closeBtn = document.querySelector('.close-button');
        this.pictureFocusDiv = document.querySelector('.picture-focus');
        this.pictureDetailDiv = document.querySelector('.picture-detail');
        this.detailButton = document.querySelector('.detail-button')
        this.backButton = document.querySelector('.back-button');
        this.mapBtn = document.querySelector('.map-button');
        this.mapDetail = document.querySelector('.map-detail');
        this.mapBack = document.querySelector('.back-button-map');
        this.infoPage = document.querySelector('.info-detail');
        this.infoBtn = document.querySelector('.info-button');
        this.infoBack=document.querySelector('.back-button-info');
        this.teleportMenuItems = document.querySelectorAll('.stbtn');
        this.sale = document.querySelectorAll('.sala');
        this.mapSelect = document.querySelectorAll('.st');
        this.menuTeleport = document.querySelectorAll('.teleport');
        this.roomWaypointsIndices = [0, 3, 7];
        this.mqp = window.matchMedia("(orientation: portrait)");


        this.setupListeners();

    }

    setupListeners() {
        this.fullScreenBtn.addEventListener('click', this.showFullScreen);
        this.exitFullScreenBtn.addEventListener('click', this.ExitFullScreen);
        addEventListener('fullscreenchange', this.fullScreenChange);
        this.mapBtn.addEventListener('click', this.showMap);
        this.mapBack.addEventListener('click', this.hideMap);
        this.infoBtn.addEventListener('click', this.showInfo);
        this.infoBack.addEventListener('click', this.hideInfo);
        this.EventEmitter.on(Events.TELEPORT, this, () => {
            this.closeBtn.dispatchEvent(this.ClickEvent);
            this.pictureDetailDiv.style.display = 'none';
            this.pictureFocusDiv.style.display = 'none';
            this.mapDetail.classList.add('hidden');
            this.mapBtn.classList.remove('active');
            //this.detailButton.style.display = 'none';
        })

        this.onTeleportMenuItemCallbacks = [];
        for (let i = 0; i < this.teleportMenuItems.length; i += 1) {
            this.onTeleportMenuItemCallbacks[i] = () => {
                this.EventEmitter.trigger(Events.TELEPORT, [
                    this.roomWaypointsIndices[i],
                ])
            };
            this.teleportMenuItems[i].addEventListener(
                'click',
                this.onTeleportMenuItemCallbacks[i]
            );
        }
        this.EventEmitter.on(Events.TELEPORT, this, (arg) => {
            for (let i = 0; i < this.teleportMenuItems.length; i += 1) {
                this.teleportMenuItems[i].classList.remove('stbtn1');
                //this.teleportMenuItems[i].classList.add('stbtn2');
                this.mapSelect[i].classList.remove('st1');
                this.mapSelect[i].classList.add('st2');
                this.sale[i].classList.remove('show');
                this.menuTeleport[i].classList.remove('active')
            }

            document.querySelector(".st[data-st='" + arg + "']").classList.add('st1');
            document.querySelector(".st[data-st='" + arg + "']").classList.remove('st2');

            document.querySelector(".sala[data-sala='" + arg + "']").classList.add('show');
            document.querySelector(".stbtn[data-st='" + arg + "']").classList.add('stbtn1');
            document.querySelector(".teleport[data-sala='" + arg + "']").classList.add('active');
        })

        for (let i = 0; i < this.mapSelect.length; i += 1) {
            this.mapSelect[i].addEventListener('click', this.changeRoom);
        }

        this.EventEmitter.on(Events.ITEM_HAS_FOCUS, this, (arg) => {
            let data = arg.artData;
            this.renderDetail(data);
        })
        this.mqp.addEventListener('change', this.blockPortrait)
        this.EventEmitter.on(Events.RESOURCES_READY, this, this.unblockEnter);
        this.setUpFullScreen();


    }


    setUpFullScreen = () => {
         if(this.isIOS()) {
             this.fullScreenBtn.style.display = 'none'; // se non funziona fullscreen sparisce
             return false;
         }
        else if (!document.documentElement.requestFullscreen && !document.documentElement.webkitRequestFullscreen && !document.documentElement.msRequestFullscreen && !document.webkitEnterFullscreen) {
            this.fullScreenBtn.style.display = 'none'; // se non funziona fullscreen sparisce
        }
    }

    showFullScreen = () => {
        if(this.isIOS()) {
            this.fullScreenBtn.style.display = 'none'; // //fuck
            return false;
        }
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.webkitRequestFullscreen) { /* Safari */
            document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) { /* IE11 */
            document.documentElement.msRequestFullscreen();
        }
       /* else if (document.webkitEnterFullscreen) { /!*IOS bloccato!*!/
            document.webkitEnterFullscreen();
        }*/
        else {
            this.fullScreenBtn.style.display = 'none'; // se non funziona fullscreen sparisce
        }
    }

    isIOS = () => {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            return true;
        } else {
            return navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /MacIntel/.test(navigator.platform);
        }
    }


    ExitFullScreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen().then(() => {

            })
                .catch((err) => console.error(err))
        } else if (document.webkitFullscreenElement) {
            document.webkitExitFullscreen();
        }
    }
    fullScreenChange = () => {
        // if (document.fullscreenElement) {
        this.exitFullScreenBtn.classList.toggle('hidden')
        this.fullScreenBtn.classList.toggle('hidden');
        /*   } else {
               this.exitFullScreenDiv.style.display = 'none'
           }*/
    }

    EnterGallery = () => {
        this.blockPortrait(this.mqp)
        document.querySelector('.intro').innerHTML = '';
        document.querySelector('.intro').classList.add('clicked');
        //window.matchMedia()
        setTimeout(() => document.querySelector('.intro').classList.add('hidden'), 3800);
    }

    showMap = () => {
        this.hideInfo();
        this.mapDetail.classList.toggle('hidden');
        this.mapBtn.classList.toggle('active');
    }
    hideMap = () => {
        this.mapDetail.classList.add('hidden');
        this.mapBtn.classList.remove('active');
    }

    unblockEnter = () => {
        this.EnterButton.classList.remove('disabled');
        document.querySelector('.spinner2').style.visibility = 'hidden';
        document.querySelector('.box').remove();
        this.EnterButton.addEventListener('click', this.EnterGallery);

    }

    renderDetail = (data) => {

        let premio = data.premio ? `<div class="premio"><span class="photo-premio">${data.premio}</span></div>` : '';

        let tpl = `${premio}
                   <div class="heading">
                    <div class="photo-author">${data.name}</div>
                    <div class="photo-title">${data.title}</div>
                    </div>
                    <div class="caption-content">
                    ${data.description}
                    </div>`;
       /* <div className="photo-type">${data.printType}</div>
        <div className="photo-size">${data.format}</div>*/
        this.detailArt.innerHTML = tpl;

    }

    changeRoom = (e) => {
        let selected = e.currentTarget;
        let s = selected.dataset.st;

        for (let i = 0; i < this.mapSelect.length; i += 1) {
            this.mapSelect[i].classList.remove('st1');
            this.mapSelect[i].classList.add('st2');
            this.sale[i].classList.remove('show');
        }
        selected.classList.add('st1');
        selected.classList.remove('st2');
        document.querySelector(".sala[data-sala='" + s + "']").classList.add('show');
    }

    blockPortrait = (m) => {
        if(window.innerWidth>1200) {
            document.querySelector('.force-landscape').classList.add('hidden');
            return false;
        }
        if (m.matches) {
            // portrait
            document.querySelector('.force-landscape').classList.remove('hidden');
        } else {
            // landscape
            document.querySelector('.force-landscape').classList.add('hidden');
        }
    }

    showInfo = () => {
        this.hideMap();
        this.infoPage.classList.toggle('hidden');
        this.infoBtn.classList.toggle('active');
    }

    hideInfo = () => {
        this.infoPage.classList.add('hidden');
        this.infoBtn.classList.remove('active');
    }
}

